import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../../../packages/kiti/components/structure/Grid'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'
import AssetSelect from '../../../../../../containers/assets/select/AssetSelect'
import BondSelect from './BondSelect'
import ChecklistSelect from '../../../../../../containers/checklists/select/ChecklistSelect'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import PlaceSelect from '../../../../../../containers/places/select/PlaceSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import UsersOrGroupsSelect from '../../../../../../containers/users/select/UsersOrGroupsSelect'
import FieldsSection from './FieldsSection'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'
import DateInputWithInterpolations from '../../../../../../packages/kiti-editor/components/date/DateInputWithInterpolations'
import { useRawInterpolations } from '../../../../../../utils/interpolations/rawInterpolations'
import TypeSelect from './TypeSelect'
import Select from '../../../../../../packages/kiti/components/form/Select'
import { usePlaceTypesWithPermission } from '../../../../../../utils/helpers/placeTypes'
import NumberInput from '../../../../../../components/form/NumberInput'
const InsertServiceOrderSentence = ({ isFuture = false, schedulerTask = null }) => {
  const [open, setOpen] = React.useState()
  const { form, handleChangeIn } = useFormState()
  const { t } = useTranslation('triggers')
  const placeTypes = usePlaceTypesWithPermission('list')

  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)
  const rawInterpolations = useRawInterpolations(form.entity, checklistId)

  const HOURS = Array.from({ length: 23 }, (_, i) => String(i + 1).padStart(2, '0'))
  const MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, '0'))

  const handleAfterChangePlaceType = () => {
    handleChangeIn(['payload', 'place'], undefined)
  }

  React.useEffect(() => {
    if (!!schedulerTask) handleChangeIn(['configuration', 'entity'], 'scheduler_task')
  }, schedulerTask)

  React.useEffect(() => {
    if (!form?.configuration?.hours) {
      handleChangeIn(['configuration', 'hours'], '01')
    }

    if (!form?.configuration?.days) {
      handleChangeIn(['configuration', 'days'], 0)
    }

    if (!form?.configuration?.minutes) {
      handleChangeIn(['configuration', 'minutes'], '00')
    }
  }, [])

  return (
    <Grid align="center" gap={1} nowrap>
      {!!isFuture && (
        <>
          <Text size="h2">após</Text>
          <EditableSentence
            label={form?.configuration?.days || '___'}
            field="value"
            Input={NumberInput}
            value={form?.configuration?.days}
            path={['configuration', 'days']}
            onChange={event => {
              if (event < 0 || !event || event == '') {
                handleChangeIn(['configuration', 'days'], 0)
              }

              handleChangeIn(['configuration', 'days'], event)
            }}
            onlyInt
            min={0}
          />
          <Text size="h2">{form?.configuration?.days > 1 ? 'dias' : 'dia'}, </Text>
          <EditableSentence
            label={form?.configuration?.hours || '___'}
            field="time"
            value={form?.configuration?.hours}
            path={['configuration', 'hours']}
            onChange={event => {
              if (event < 1 || !event || event == '') {
                handleChangeIn(['configuration', 'hours'], '01')
              }

              handleChangeIn(['configuration', 'hours'], event)
            }}
            options={HOURS}
            truncate={15}
            width={10}
          />
          <Text size="h2">{form?.configuration?.hours > 1 ? 'horas' : 'hora'} e</Text>
          <EditableSentence
            label={form?.configuration?.minutes || '___'}
            field="value"
            value={form?.configuration?.minutes}
            path={['configuration', 'minutes']}
            onChange={event => {
              if (event < 0 || !event || event == '') {
                handleChangeIn(['configuration', 'minutes'], '00')
              }

              handleChangeIn(['configuration', 'minutes'], event)
            }}
            options={MINUTES}
            truncate={15}
            width={10}
          />
          <Text size="h2">{form?.configuration?.minutes > 1 ? 'minutos' : 'minuto'}</Text>
        </>
      )}
      <Text size="h2">de</Text>
      <EditableSentence
        label={form.payload?.checklist?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="42rem">
        <Grid paddingGutter={0.5} wrap>
          <Col width="100%">
            <FormItem
              label={t('fields.name')}
              path={['payload', 'name']}
              Input={InputWithInterpolations}
              interpolations={interpolations}
            />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.destinationType')}
              path={['payload', 'placeType']}
              Input={Select}
              options={placeTypes.map(type => ({ id: type.id, value: type.key, name: type.namePlural }))}
              afterChange={handleAfterChangePlaceType}
            />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.placePerson')}
              path={['payload', 'place']}
              Input={PlaceSelect}
              type={form?.payload?.placeType?.value}
              interpolations={rawInterpolations}
            />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.asset')}
              path={['payload', 'asset']}
              Input={AssetSelect}
              filter={{ placeIds: form?.payload?.place?.id }}
              disabled={!form?.payload?.place?.id}
              interpolations={rawInterpolations}
            />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.checklist')}
              path={['payload', 'checklist']}
              Input={ChecklistSelect}
              interpolations={rawInterpolations}
            />
          </Col>

          <Col width="50%">
            <FormItem
              label={t('fields.schedulingDate')}
              path={['payload', 'scheduling']}
              Input={DateInputWithInterpolations}
              interpolations={rawInterpolations}
              useTime
            />
          </Col>

          <Col width="100%">
            <FormItem
              label={t('fields.user')}
              path={['payload', 'user_or_group']}
              Input={UsersOrGroupsSelect}
              interpolations={rawInterpolations}
            />
          </Col>

          <Col width="100%">
            <BondSelect />
          </Col>

          <Col width="100%">
            <TypeSelect />
          </Col>

          <Col width="100%">
            <FormItem
              label={t('fields.metadata')}
              path={['payload', 'metadata']}
              interpolations={rawInterpolations}
              Input={InputWithInterpolations}
            />
          </Col>

          <Col width="100%">
            <FieldsSection />
          </Col>
        </Grid>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </Grid>
  )
}

export default InsertServiceOrderSentence
